import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AuthWatcher from './Components/AuthWatcher';

// Layouts
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';

// Pantallas públicas
import Home from './Screens/Home';
import PieDeWeb from './Screens/PieDeWeb';
import Noticia from './Screens/Noticia';
import ActualidadNav from './Screens/ActualidadNav/ActualidadNav';

// Ayuntamiento
import SaludoDelAlcalde from './Screens/Ayuntamiento/SaludoDelAlcalde';
import CorporacionMunicipal from './Screens/Ayuntamiento/CorporacionMunicipal';
import OrganosGobierno from './Screens/Ayuntamiento/OrganosGobierno';
import PlenosVideo from './Screens/Ayuntamiento/PlenosVideo';
import ActasPleno from './Screens/Ayuntamiento/ActasPleno';
import Ordenanzas from './Screens/Ayuntamiento/Ordenanzas';

// Pueblo
import DatosInteres from './Screens/Pueblo/DatosInteres';
import Fiestas from './Screens/Pueblo/Fiestas';
import LugaresHistoricos from './Screens/Pueblo/LugaresHistoricos';
import Fotos from './Screens/Pueblo/Fotos';

// Economía Local
import Alojamientos from './Screens/EconomiaLocal/Alojamientos';
import EmpresasLocales from './Screens/EconomiaLocal/EmpresasLocales';

// Asociaciones
import Asociaciones from './Screens/Asociaciones/Asociaciones';

// Empleo
import Empleo from './Screens/Empleo/Empleo';
import DetalleEmpleo from './Screens/Empleo/DetalleEmpleo';

// Auth
import Login from './Components/Login';
import AdminPanel from './Components/AdminPanel';
import ResetPassword from './Components/ResetPassword';

// IA
import ChatPage from './Screens/ChatPage';

// Servicios
import ReservaPistas from './Screens/ReservaPistas';
import Actividades from './Screens/Actividades';
import Confirmacion from './Screens/Confirmacion';
import Cancelacion from './Screens/Cancelacion';

// Ruta protegida
import PrivateRoute from './Components/PrivateRoute';

const Rutas = () => {
  return (
    <>
      <AuthWatcher />
      <Routes>

        {/* Rutas públicas con layout principal */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/ayuntamiento/saludo-alcalde" element={<SaludoDelAlcalde />} />
          <Route path="/ayuntamiento/corporacion-municipal" element={<CorporacionMunicipal />} />
          <Route path="/ayuntamiento/organos-gobierno" element={<OrganosGobierno />} />
          <Route path="/ayuntamiento/plenos-video" element={<PlenosVideo />} />
          <Route path="/ayuntamiento/actas-pleno" element={<ActasPleno />} />
          <Route path="/ayuntamiento/ordenanzas" element={<Ordenanzas />} />
          <Route path="/actualidad" element={<ActualidadNav />} />
          <Route path="/empleo" element={<Empleo />} />
          <Route path="/empleo/auxiliar-ayuda-domicilio" element={<DetalleEmpleo />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/noticia/:id" element={<Noticia />} />
          <Route path="/servicios/reserva-pistas" element={<ReservaPistas />} />
          <Route path="/pie-de-web" element={<PieDeWeb />} />
          <Route path="/pueblo/datos-interes" element={<DatosInteres />} />
          <Route path="/pueblo/fiestas" element={<Fiestas />} />
          <Route path="/pueblo/lugares-historicos" element={<LugaresHistoricos />} />
          <Route path="/pueblo/fotos" element={<Fotos />} />
          <Route path="/pueblo/asociaciones" element={<Asociaciones />} />
          <Route path="/economia-local/alojamientos" element={<Alojamientos />} />
          <Route path="/economia-local/empresas" element={<EmpresasLocales />} />
          <Route path="/servicios/actividades" element={<Actividades />} />
          <Route path="/servicios/confirmacion" element={<Confirmacion />} />
          <Route path="/servicios/pago-cancelado" element={<Cancelacion />} />
        </Route>

        {/* Rutas de login */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/login/forgot-password" element={<ResetPassword />} />
        </Route>

        {/* Ruta protegida */}
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />

      </Routes>
    </>
  );
};

export default Rutas;
